var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('summary-table',{attrs:{"data-field":"poy","format-type":"poy"}})}
var staticRenderFns = []

export { render, staticRenderFns }